<template>
  <svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 390 422">
    <defs></defs>
    <path :fill="color" d="M352.21,0H61V422H451V98.79ZM361,51.21,399.79,90H361ZM91,392V30H331v90h90V392Z" transform="translate(-61)"/>
    <rect :fill="color2" x="60" y="90" width="180" height="30"/>
    <rect :fill="color2" x="60" y="208" width="210" height="30"/>
    <rect :fill="color2" x="60" y="288" width="210" height="30"/>
  </svg>
</template>

<script>
export default {
  props: {
    color: {
      type: String,
      default: '#FB923C',
      required: false,
    },
    color2: {
      type: String,
      default: '#FB923C',
      required: false,
    },
  },
};
</script>
